// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Usuarios_DesabilitaUsuarioInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /usuarios/desabilitaUsuario
 *
 * Disables a user account by their Cognito sub.
 */
import { registerContract } from './validate'

export interface Usuarios_DesabilitaUsuarioInput {
sub: string
}

registerContract('Usuarios_DesabilitaUsuarioInput', {
  sub: { type: 'string',  required: true },
})
